

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { ClassificaDTO } from "../dto/classificaDTO";
import { ClassificaVO } from "../vo/classificaVO";
import { RiferimentoEsternoDTO } from "../dto/riferimento-esternoDTO";
import { RiferimentoEsternoVO } from "../vo/riferimento-esternoVO";



@Injectable({
    providedIn: 'root'
})
export class MapperRiferimentoFascicoloEsterno implements MapperInterface<RiferimentoEsternoDTO, RiferimentoEsternoVO> {

    convertVoToDto(vo: RiferimentoEsternoVO): RiferimentoEsternoDTO {
        if (vo != null) {
            const dto = new RiferimentoEsternoDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.id = vo.id;
            dto.sistema = vo.sistema;
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: RiferimentoEsternoDTO): RiferimentoEsternoVO {
        if (dto != null) {
            const vo = new RiferimentoEsternoVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.id = dto.id;
            vo.sistema = dto.sistema;

            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: RiferimentoEsternoVO[]): RiferimentoEsternoDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: RiferimentoEsternoDTO[]): RiferimentoEsternoVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
